import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["hideable", "showable", "dynamic"];

  toggle(_event) {
    this.dynamicTargets.forEach((target) => {
      target.classList.toggle("hidden");
    });
  }

  hide(_event) {
    this.hideableTargets.forEach((target) => {
      target.classList.add("hidden");
    });
    this.dynamicTargets.forEach((target) => {
      target.classList.add("hidden");
    });
  }

  show(_event) {
    this.showableTargets.forEach((target) => {
      target.classList.remove("hidden");
    });
    this.dynamicTargets.forEach((target) => {
      target.classList.remove("hidden");
    });
  }
}
